import React, { useContext } from 'react';
import { bool, string } from 'prop-types';
import PopupContext from '../../context/PopupContext.js';
import Backdrop from '../Backdrop/index.jsx';
const PopupBackdrop = ({
  active,
  className
}) => {
  const {
    setActivePopup
  } = useContext(PopupContext);
  return /*#__PURE__*/React.createElement(Backdrop, {
    className: className,
    active: active,
    onClick: () => setActivePopup(null)
  });
};
PopupBackdrop.defaultProps = {
  active: false,
  className: null
};
PopupBackdrop.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Show the backdrop. */
  active: bool,
  /** Additional class names to add to the component. */
  className: string
} : {};
export default PopupBackdrop;